export default __webpack_public_path__ + "static/media/ic_remove.b2629008.svg";